import React from 'react';

import DossierTeaser from './Teaser';
import DossierHighlighted from './Highlighted';
import DossierFull from './Full';
import DossierMenu from './Menu';

const DossierFile = (props) => {
  const { viewMode, showAsMenuItem = false } = props;
  if (viewMode === 'teaser') {
    return <DossierTeaser {...props} />;
  }

  if (viewMode === 'highlighted') {
    return <DossierHighlighted {...props} />;
  }

  if (showAsMenuItem) {
    return <DossierMenu {...props} />;
  }

  return <DossierFull {...props} />;
};

export default DossierFile;
